import { createContext } from "react";

const HistoricalReportContext = createContext<
  InitialHistoricalReportStateType[]
>([]);

export default HistoricalReportContext;
